import { Injectable } from "@angular/core";
import { GenericService } from "../generic.service";
import { Observable } from "rxjs";
import { MentorStudentsRequest } from "../../models/account/mentor/mentorStudentsRequest";
import { apiResponse } from "../../models/apiResponse";
import { MentorStudentResponse } from "../../models/account/mentor/mentorStudentsResponse";

@Injectable({providedIn: 'root'})

export class MentorDashboardService {

  constructor(private genericService: GenericService) { }

  searchMentorStudents(mentorStudentRequest:MentorStudentsRequest):Observable<apiResponse<MentorStudentResponse[]>>
  {
    return this.genericService.post('mentor-students',mentorStudentRequest);
  };

}